angular.module('impactx.relationView').controller('ClassificationRelationViewController', [
    '$scope',
    ClassificationRelationViewController]);

function ClassificationRelationViewController($scope) {

    $scope.refreshMainEntries = function () {
        if (!impactX.isDefined($scope, "relation.main.selected.id") && $scope.relation.assigned.length > 0 &&
            (($scope.relation.assigned[0].selected && $scope.relation.assigned[0].selected.id > 0) ||
                ($scope.relation.assigned[0].freeSelection && $scope.relation.assigned[0].freeSelection.value))) {
            $scope.relation.main = $scope.relation.assigned[0];
        }
    };

    $scope.deleteItem = function (item) {
        if (item) {
            var index = -1;
            for (var i = 0; i < $scope.relation.assigned.length; i++) {
                if (item.selected) {
                    if ($scope.relation.main && $scope.relation.main.selected && $scope.relation.main.selected.id === item.selected.id) {
                        $scope.relation.main = null;
                    }
                    if ($scope.relation.assigned[i].selected && $scope.relation.assigned[i].selected.id === item.selected.id) {
                        index = i;
                        break;
                    }
                }
                else if (item.freeSelection) {
                    if ($scope.relation.main && $scope.relation.main.freeSelection && $scope.relation.main.freeSelection.value === item.freeSelection.value) {
                        $scope.relation.main = null;
                    }
                    if ($scope.relation.assigned[i].freeSelection && $scope.relation.assigned[i].freeSelection.value === item.freeSelection.value) {
                        index = i;
                        break;
                    }
                }
            }
            if (index >= 0) {
                $scope.relation.assigned.splice(index, 1);
            }
        }
        else {
            $scope.relation.assigned.splice($scope.relation.assigned.length - 1, 1);
        }
        $scope.refreshMainEntries();
    };

    $scope.setSelected = function (selected) {
        if (selected) {
            $scope.relation.assigned[$scope.relation.assigned.length - 1].selected = selected;
            $scope.refreshMainEntries();
        }
    };

    $scope.addEntry = function () {
        var entry = {};
        if ($scope.relation.useFreeSelection) {
            entry.freeSelection = {
                value: undefined
            };
            if ($scope.relation.assigned.length === 0 || $scope.relation.assigned[$scope.relation.assigned.length - 1].freeSelection.value) {
                $scope.relation.assigned.push(entry);
                $scope.refreshMainEntries();
            }
        }
        else {
            entry.selected = {
                id: -1,
                value: undefined
            };
            if ($scope.relation.assigned.length === 0 || $scope.relation.assigned[$scope.relation.assigned.length - 1].selected.id > 0) {
                $scope.relation.assigned.push(entry);
                $scope.refreshMainEntries();
            }
        }

    };

    $scope.markAsMainClassification = function (classificationEntry) {
        $scope.relation.main = classificationEntry;
    };
}

